<div id="emojis-id">
  <div class="emojis">
    <div class="emoji-list">
      <div mat-menu-item class="emoji" *ngFor="let e of emojiList" title="{{ e }}" (click)="clickEmoji(e)">
        <span [innerHTML]="getEmoji(e)"></span>
      </div>
    </div>
  </div>
</div>
